var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircleLoading(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 203,
    viewBox: "0 0 203 203",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2_2989)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.979 194.984C155.562 194.984 199 151.552 199 97.9761C199 44.4001 155.562 0.96814 101.979 0.96814C48.3965 0.96814 4.95898 44.4001 4.95898 97.9761C4.95898 151.552 48.3965 194.984 101.979 194.984Z",
    fill: "url(#paint0_linear_2_2989)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.979 184.156C149.58 184.156 188.168 145.572 188.168 97.9778C188.168 50.3831 149.58 11.8 101.979 11.8C54.3781 11.8 15.79 50.3831 15.79 97.9778C15.79 145.572 54.3781 184.156 101.979 184.156Z",
    fill: "url(#paint1_linear_2_2989)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M133.271 66.6545L141.859 42.7253L159.473 40.4565L157.216 58.0806L133.271 66.6545ZM143.814 45.1571L137.696 62.2923L154.771 56.1753L156.389 43.6403L143.814 45.1571Z",
    fill: "#D8642D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M157.943 42.02L135.502 64.4701L156.012 57.1121L157.943 42.02Z",
    fill: "url(#paint2_linear_2_2989)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M157.943 42.02L135.502 64.4701L142.861 43.9629L157.943 42.02Z",
    fill: "#FFF473"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.61
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M157.943 42.02L142.949 43.9504L156.025 57.0243L157.943 42.02Z",
    fill: "white"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M147.938 50.7694L142.949 43.9504L157.943 42.02L135.502 64.4701L147.938 50.7694Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4 129.515L61.8249 153.457L44.1987 155.713L46.4676 138.164L70.4 129.515ZM59.8569 151.012L65.9871 133.94L48.8999 140.007L47.2952 152.542L59.8569 151.012Z",
    fill: "#D8642D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.728 154.161L68.1685 131.711L47.6587 139.069L45.728 154.161Z",
    fill: "#FFF473"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M45.728 154.161L68.1685 131.711L60.8221 152.218L45.728 154.161Z",
    fill: "url(#paint3_linear_2_2989)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M45.728 154.159L60.7218 152.229L47.6461 139.155L45.728 154.159Z",
    fill: "#D8642D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9552 131.921L54.0522 144.331L47.646 139.154L54.1901 145.684L67.9552 131.921Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7287 66.4298L47.7837 57.8559L45.5271 40.2318L63.0783 42.4881L71.7287 66.4298ZM50.2158 55.8879L67.3033 62.005L61.1727 44.9324L48.6361 43.3154L50.2158 55.8879Z",
    fill: "#D8642D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M47.082 41.7583L69.535 64.1959L62.1761 43.6887L47.082 41.7583Z",
    fill: "#FFF473"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M47.082 41.7583L69.535 64.1959L49.0252 56.8504L47.082 41.7583Z",
    fill: "url(#paint4_linear_2_2989)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M47.082 41.7583L49.0001 56.7626L62.0883 43.6762L47.082 41.7583Z",
    fill: "#FFF473"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3967 50.1567L62.2387 43.8516L55.6069 49.3796L47.082 41.7583L69.535 64.1959L56.3967 50.1567Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M157.504 136.837L159.761 154.386L142.184 152.205L133.597 128.251L157.504 136.837ZM156.677 151.365L155.059 138.83L137.984 132.701L144.102 149.786L156.677 151.365Z",
    fill: "#D8642D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M158.231 152.895L135.791 130.457L156.3 137.803L158.231 152.895Z",
    fill: "#FFF473"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M158.231 152.895L135.791 130.457L143.137 150.964L158.231 152.895Z",
    fill: "url(#paint5_linear_2_2989)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M158.231 152.893L143.237 150.975L156.313 137.888L158.231 152.893Z",
    fill: "#D8642D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M149.831 143.581L156.15 137.753L150.621 144.371L158.231 152.895L135.791 130.457L149.831 143.581Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M101.992 0.957275L4.95898 97.9652L16.3671 109.385L101.992 194.986L187.592 109.385L199 97.9652L101.992 0.957275ZM21.6703 104.082L15.7653 98.2034L15.5398 97.9652L50.191 63.3312L50.2911 63.2434L97.7421 15.7861L101.992 11.5368L102.381 11.9379L188.432 97.9652L187.654 98.7424L182.313 104.082L102.381 184.005L101.992 184.406L21.6703 104.082Z",
    fill: "#DE6228"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M102.417 6.28085L10.6855 98.0008L102.417 189.721L194.149 98.0008L102.417 6.28085Z",
    fill: "url(#paint6_linear_2_2989)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M102.393 6.24805V21.7914L25.757 98.6557L10.6504 97.9788L102.393 6.24805Z",
    fill: "white"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8396 15.3483C98.7201 13.5308 97.8801 23.1827 95.5859 24.5616C93.2917 25.9404 36.827 86.5218 33.7806 84.5914C30.7342 82.661 71.9043 39.453 96.8396 15.3483Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M194.123 97.9783L178.728 99.8334L102.393 175.983V189.696L194.123 97.9783Z",
    fill: "#FF771E"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M101.983 20.8386L24.8335 97.9783L101.983 175.118L179.132 97.978L101.983 20.8386Z",
    fill: "url(#paint7_linear_2_2989)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7603 97.275L52.7736 98.6789L102.682 145.773L56.5471 98.0647L103.208 51.4097L151.186 97.275L104.261 47.1979L102.682 21.3634L100.751 50.3567L55.2308 95.8711L26.7603 97.275Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4,
    d: "M101.937 51.1412L56.8069 96.2654L101.937 141.39L147.067 96.2654L101.937 51.1412Z",
    fill: "url(#paint8_linear_2_2989)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M104.536 32.2064L105.752 50.8459L148.189 93.2767L168.172 95.8463L104.536 32.2064Z",
    fill: "url(#paint9_linear_2_2989)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M37.1406 99.5953L55.7825 100.824L98.2188 143.242L100.789 163.223L37.1406 99.5953Z",
    fill: "url(#paint10_linear_2_2989)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.25,
    d: "M167.772 99.9943L149.13 101.223L106.706 143.641L104.124 163.634L167.772 99.9943Z",
    fill: "url(#paint11_linear_2_2989)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M99.4335 31.6696L99.1577 51.2491L56.734 93.6799L35.7854 95.3095L99.4335 31.6696Z",
    fill: "url(#paint12_linear_2_2989)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.53,
    d: "M86.6223 68.7594L126.401 75.7539L146.986 96.3363L73.8726 82.8236L126.351 116.981L109.827 133.49L64.8713 90.495L86.6223 68.7594Z",
    fill: "url(#paint13_linear_2_2989)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4,
    d: "M57.7751 99.5836C57.7751 99.5836 73.12 121.344 96.5007 99.5836C112.798 84.4539 144.629 96.8008 144.629 96.8008C144.629 96.8008 103.258 57.4411 102.079 56.9522C100.901 56.4634 52.1337 99.8969 57.7751 99.5836Z",
    fill: "url(#paint14_linear_2_2989)"
  }), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M101.979 152.093L47.8591 97.98L101.979 43.8541L156.112 97.98L101.979 152.093ZM51.382 97.98L101.979 148.571L152.577 97.98L101.979 47.389L51.382 97.98ZM101.979 146.378L53.5759 97.98L101.979 49.5701L150.395 97.98L101.979 146.378ZM57.0984 97.98L101.979 142.855L146.873 97.98L101.979 53.0924L57.0984 97.98Z",
    fill: "#D8642D"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M101.979 45.6183L49.6265 97.9767L101.979 150.323L154.345 97.9767L101.979 45.6183ZM55.3307 97.9767L101.979 51.3217L148.628 97.9767L101.979 144.619L55.3307 97.9767Z",
    fill: "url(#paint15_linear_2_2989)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M101.942 53.5173L91.0852 30.5157L101.942 16.4641L112.799 30.5157L101.942 53.5173ZM94.1942 30.8541L101.942 47.2499L109.69 30.8416L101.942 20.8136L94.1942 30.8541Z",
    fill: "#D8642D"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M101.967 18.657V50.408L111.269 30.7031L101.967 18.657Z",
    fill: "url(#paint16_linear_2_2989)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M101.967 18.657V50.408L92.6648 30.7031L101.967 18.657Z",
    fill: "#FFF473"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.61
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M101.967 18.657L92.7278 30.6279H111.219L101.967 18.657Z",
    fill: "white"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M101.077 31.919L92.7278 30.6279L101.967 18.657V50.408L101.077 31.919Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M101.942 142.415L112.799 165.417L101.942 179.468L91.0852 165.417L101.942 142.415ZM109.69 165.078L101.942 148.67L94.1942 165.078L101.942 175.106L109.69 165.078Z",
    fill: "#D8642D"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M101.917 177.285V145.547L92.6021 165.252L101.917 177.285Z",
    fill: "#FFF473"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M101.916 177.285V145.547L111.218 165.252L101.916 177.285Z",
    fill: "url(#paint17_linear_2_2989)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M101.917 177.286L111.156 165.328H92.6648L101.917 177.286Z",
    fill: "#D8642D"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M101.917 145.848L100.851 164.45L92.6648 165.327H101.917V145.848Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2519 96.874L35.2597 107.742L21.2063 96.874L35.2597 86.0187L58.2519 96.874ZM35.6233 104.621L52.0338 96.874L35.6233 89.1274L25.5941 96.874L35.6233 104.621Z",
    fill: "#D8642D"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3872 96.8488H55.1298L35.4223 87.5479L23.3872 96.8488Z",
    fill: "#FFF473"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3872 96.8499H55.1298L35.4223 106.151L23.3872 96.8499Z",
    fill: "url(#paint18_linear_2_2989)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M23.3872 96.8515L35.3471 106.102V87.6133L23.3872 96.8515Z",
    fill: "#FFF473"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9112 96.21L35.5727 87.6236L34.7955 96.21L23.3872 96.8493H55.1298L35.9112 96.21Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M168.712 86.0187L182.765 96.874L168.712 107.742L145.707 96.874L168.712 86.0187ZM178.389 96.874L168.36 89.1274L151.95 96.874L168.36 104.621L178.389 96.874Z",
    fill: "#D8642D"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M180.584 96.8488H148.829L168.536 87.5479L180.584 96.8488Z",
    fill: "#FFF473"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M180.584 96.8499H148.829L168.536 106.151L180.584 96.8499Z",
    fill: "url(#paint19_linear_2_2989)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M180.584 96.8515L168.612 106.102V87.6133L180.584 96.8515Z",
    fill: "#D8642D"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M168.047 96.21L168.386 87.6236L169.163 96.21L180.584 96.8493H148.829L168.047 96.21Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2_2989",
    x: 0.958984,
    y: 0.957275,
    width: 202.041,
    height: 202.028,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_2989"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_2989",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_2989",
    x1: 5.97445,
    y1: 97.9761,
    x2: 197.533,
    y2: 97.9761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F5B042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_2989",
    x1: 188.82,
    y1: 97.9778,
    x2: 18.9116,
    y2: 97.9778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_2989",
    x1: 137.681,
    y1: 76.1458,
    x2: 155.141,
    y2: 42.9588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDAE59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#FDAF55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEB44B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFBC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFC02E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF844"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_2989",
    x1: 53.44,
    y1: 152.721,
    x2: 67.2835,
    y2: 114.962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDAE59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#FDAF55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEB44B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFBC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFC02E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF844"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2_2989",
    x1: 48.5139,
    y1: 49.4791,
    x2: 86.2763,
    y2: 63.3271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDAE59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#FDAF55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEB44B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFBC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFC02E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF844"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2_2989",
    x1: 172.705,
    y1: 168.736,
    x2: 158.805,
    y2: 130.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDAE59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#FDAF55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEB44B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFBC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFC02E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF844"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2_2989",
    x1: 96.549,
    y1: 55.2335,
    x2: 120.864,
    y2: 231.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F5B042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2_2989",
    x1: 24.8249,
    y1: 97.9674,
    x2: 179.138,
    y2: 97.9677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000A94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2_2989",
    x1: 110.465,
    y1: 104.836,
    x2: 78.0863,
    y2: 72.4538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2_2989",
    x1: 125.753,
    y1: 52.7872,
    x2: 176.766,
    y2: 103.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2_2989",
    x1: 51.8614,
    y1: 105.519,
    x2: 102.658,
    y2: 156.323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2_2989",
    x1: 178.919,
    y1: 101.762,
    x2: 115.019,
    y2: 165.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2_2989",
    x1: 94.0136,
    y1: 46.8119,
    x2: 43.2078,
    y2: 97.6243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2_2989",
    x1: 139.826,
    y1: 124.619,
    x2: 122.757,
    y2: 101.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2_2989",
    x1: 116.22,
    y1: 107.484,
    x2: 116.069,
    y2: 68.3511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2_2989",
    x1: 92.8402,
    y1: 74.2607,
    x2: 115.902,
    y2: 134.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F5B042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2_2989",
    x1: 111.77,
    y1: 57.1142,
    x2: 100.641,
    y2: 21.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDAE59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#FDAF55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEB44B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFBC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFC02E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF844"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2_2989",
    x1: 106.354,
    y1: 170.817,
    x2: 89.446,
    y2: 134.327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDAE59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#FDAF55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEB44B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFBC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFC02E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF844"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2_2989",
    x1: 29.8561,
    y1: 101.3,
    x2: 66.3483,
    y2: 84.3866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDAE59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#FDAF55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEB44B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFBC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFC02E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF844"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2_2989",
    x1: 174.115,
    y1: 101.3,
    x2: 137.623,
    y2: 84.3866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDAE59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#FDAF55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEB44B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFBC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFC02E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF844"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleLoading);
export default __webpack_public_path__ + "static/media/circle-loading.31bcee6c678fbde69d3c1a56076b1dcd.svg";
export { ForwardRef as ReactComponent };